'use strict';
document.addEventListener('DOMContentLoaded', function() {
    var burgerMenu = document.getElementById('burgerMenu');
    var mobileMenu = document.getElementById('mobileMenu');
    var closeMenu = document.getElementById('closeMenu');
    var backdrop = document.getElementById('backdrop');
    burgerMenu.addEventListener('click', function() {
        mobileMenu.classList.add('active');
        backdrop.classList.add('active');
        document.body.style.overflow = 'hidden';
    });
    closeMenu.addEventListener('click', function() {
        mobileMenu.classList.remove('active');
        backdrop.classList.remove('active');
        document.body.style.overflow = 'auto';
    });
    mobileMenu.addEventListener('click', function(e) {
        if (e.target === mobileMenu) {
            mobileMenu.classList.remove('active');
            backdrop.classList.remove('active');
            document.body.style.overflow = 'auto';
        }
    });
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && mobileMenu.classList.contains('active')) {
            mobileMenu.classList.remove('active');
            backdrop.classList.remove('active');
            document.body.style.overflow = 'auto';
        }
    });
});
document.addEventListener('DOMContentLoaded', function() {
    var burgerMenu = document.getElementById('burgerMenu');
    var mobileMenu = document.getElementById('mobileMenu');
    var closeMenu = document.getElementById('closeMenu');
    if (burgerMenu) burgerMenu.addEventListener('click', function() {
        mobileMenu.classList.add('active');
    });
    if (closeMenu) closeMenu.addEventListener('click', function() {
        mobileMenu.classList.remove('active');
    });
    var mobileMenuLinks = document.querySelectorAll('.mobile-menu__link');
    mobileMenuLinks.forEach(function(link) {
        link.addEventListener('click', function() {
            mobileMenu.classList.remove('active');
            document.getElementById('backdrop').classList.remove('active');
            document.body.style.overflow = 'auto';
        });
    });
    var sliderWrapper = document.querySelector('.gallery-slider__wrapper');
    var slides = document.querySelectorAll('.gallery-slider__slide');
    var dotsContainer = document.querySelector('.gallery-slider__dots');
    if (sliderWrapper && slides.length > 0) {
        var _loop = function(i) {
            var dot = document.createElement('div');
            dot.classList.add('gallery-slider__dot');
            if (i === 0) dot.classList.add('active');
            dot.addEventListener('click', function() {
                goToSlide(i);
            });
            dotsContainer.appendChild(dot);
        };
        var currentIndex = 0;
        var totalSlides = slides.length;
        var updateDots = function() {
            dots.forEach(function(dot, index) {
                dot.classList.toggle('active', index === currentIndex);
            });
        };
        var goToSlide = function(index) {
            var slideWidth = slides[0].clientWidth;
            sliderWrapper.style.transform = "translateX(-".concat(index * slideWidth, "px)");
            currentIndex = index;
            updateDots();
        };
        for(var i = 0; i < totalSlides; i++)_loop(i);
        var dots = document.querySelectorAll('.gallery-slider__dot');
        window.addEventListener('resize', function() {
            goToSlide(currentIndex);
        });
    }
    var scrollToTopButton = document.getElementById('scrollToTop');
    if (scrollToTopButton) scrollToTopButton.addEventListener('click', function() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });
});

//# sourceMappingURL=Museum.9a4485f4.js.map
